import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Calculator from "@/pages/Calculator";
import Planner from "@/pages/Planner";
import EventDetail from "@/pages/EventDetail";
import Checklist from "@/pages/Checklist";
import Compare from "@/pages/Compare";
import Dashboard from "@/pages/Dashboard";
import Products from "@/pages/Products";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import { ProProvider } from "@/lib/pro";

function App() {
  return (
    <div className="App">
      <ProProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Landing />} />
              <Route path="/calculator" element={<Calculator />} />
              <Route path="/planner" element={<Planner />} />
              <Route path="/event/:id" element={<EventDetail />} />
              <Route path="/checklist" element={<Checklist />} />
              <Route path="/compare" element={<Compare />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/products" element={<Products />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ProProvider>
    </div>
  );
}

export default App;
